module.exports = __webpack_public_path__ + "0ff6f77c6f2cf84b98fa9d079d64b446.svg";